(function() {
    var m = angular.module('utils');

    m.directive('popover', [function() {
        return {
            restrict: 'A',
            link: function postLink(scope, element, attrs) {

                var el = $(element);
                var eventTrigger;

                if (attrs.popoverTrigger &&
                    attrs.popoverTrigger != 'click' &&
                    attrs.popoverTrigger != 'hover' &&
                    attrs.popoverTrigger != 'focus') {
                    eventTrigger = attrs.popoverTrigger;
                    attrs.popoverTrigger = 'manual'
                }

                var popoverConfig = {
                    html: true,
                    container: 'body',
                    content: attrs.popoverContent ? attrs.popoverContent : ' ',
                    placement: attrs.popoverPlacement ? attrs.popoverPlacement : 'top',
                    delay: attrs.popoverDelay,
                    trigger: attrs.popoverTrigger
                };

                el.popover(popoverConfig);

                if (attrs.popoverClassModifier) {
                    el.on('inserted.bs.popover', function() {
                        el.data('bs.popover').tip().addClass('popover--' + attrs.popoverClassModifier);
                    });
                }

                if (attrs.popoverExpression) {
                    el.on('inserted.bs.popover', function() {
                        var contents = scope.$eval(attrs.popoverExpression);
                        el.data('bs.popover').tip().find('.popover-content').html(contents);
                    });
                }

                if (eventTrigger) {
                    var timeout;
                    var makeTimeout = function() {
                        clearTimeout(timeout);
                        timeout = setTimeout(function() {
                            el.popover('hide');
                        }, attrs.popoverDelay);
                    };

                    scope.$on(eventTrigger, function() {
                        el.popover('show');
                        makeTimeout();
                    });

                    el.on('hide.bs.popover', function() {
                        clearTimeout(timeout);
                    })

                    el.data('bs.popover').tip().find('.popover-content').on('mouseover', function() {
                        clearTimeout(timeout);
                    });

                    el.data('bs.popover').tip().find('.popover-content').on('mouseout', function() {
                        makeTimeout();
                    });

                }
            }
        }
    }]);
})();
